import styled from 'styled-components';
import { guidelineColors } from 'components/colorCodes';

export const PrimaryHeaderContainer = styled.div`
    font-size: 22px;
    color: ${guidelineColors.text.grey1};
`;

export default {
    PrimaryHeaderContainer
};
